import { IRootState } from '../../root'

export const selectDuplicateOrderCheck = (state: IRootState) => state.order.duplicateOrderChecks
